import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

interface StyleProps {
  hasAbsoluteActionButton?: boolean;
  compact?: boolean;
}

const styles = makeStyles((props: StyleProps) => ({
  container: {
    position: "relative",
    minHeight: props.compact ? "auto" : "calc(100vh - 300px)",
    paddingBottom: props.hasAbsoluteActionButton ? "40px" : undefined,
  },
  containerView: {
    position: "relative",
    paddingBottom: 20,
  },
  typeFolder: {
    color: "#465869",
    fontFamily: "Manrope",
    fontSize: "22px",
    lineHeight: "28px",
    fontWeight: 700,
  },
  switchToText: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "14px",
    color: "#3F6280",
    marginLeft: "12px",
  },
  title: {
    fontSize: "24px",
    color: "#465869",
    fontWeight: 700,
    lineHeight: "36px",
    marginBottom: "10px",
  },
  button: {
    background: "#308CDB",
    color: "#FFFFFF",
    fontSize: "14px",
    padding: "5px 8px",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #20639D",
    width: "100%",
    height: "32px",
  },
  iconButton: {
    marginRight: "5px",
  },
  buttons: props.hasAbsoluteActionButton
    ? {
        position: "absolute",
        bottom: 0,
        right: 0,
      }
    : {
        display: "flex",
        justifyContent: "end",
      },
}));

export const HeaderContainer = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
}));

export default styles;
